import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import usersReducer from "../features/users/userSlice";
import modReducer from "../features/mod/modSlice";
import trainingReducer from "../features/training/trainingSlice";
import diaryReducer from "../features/diary/diarySlice";
import mealsReducer from "../features/meals/mealsSlice";
import questionsReducer from "../features/faq/faqSlice";
import messagingReducer from "../features/messaging/messagingSlice";

export const store = configureStore({
  reducer: {
    adminauth: authReducer,
    users: usersReducer,
    mod: modReducer,
    meals: mealsReducer,
    training: trainingReducer,
    diary: diaryReducer,
    questions: questionsReducer,
    messaging: messagingReducer,
  }
});
